var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"id":"occupancy-chart","width":"90%","height":"40%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }